import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Icon } from '@scentregroup/ui'
import { pluralise } from '../../helpers'
import style from './index.module.scss'

const buildReviewLabel = reviewCount =>
  `${reviewCount} ${pluralise(reviewCount, 'rating')}`

const ariaLabelForReview = (starRating, starTotal) =>
  `Rated ${starRating} of ${starTotal} stars`

const StarRating = ({ className, starRating, starTotal, reviewCount }) => (
  <span
    aria-label={ariaLabelForReview(starRating, starTotal)}
    className={classNames(style.starRating, className)}
  >
    {[...Array(starTotal)].map((_, i) => (
      <Icon
        type="star"
        size="small"
        key={i}
        className={classNames(style.star, {
          [style.starEmpty]: i >= starRating,
        })}
      />
    ))}
    {reviewCount && (
      <span className={style.reviewText}>{buildReviewLabel(reviewCount)}</span>
    )}
  </span>
)

StarRating.propTypes = {
  starRating: PropTypes.number,
  starTotal: PropTypes.number,
  reviewCount: PropTypes.number,
  className: PropTypes.string,
}

StarRating.defaultProps = {
  starTotal: 5,
}

export default StarRating
